import type { FC } from "react";
import React from "react";
import { Text } from "@mittwald/flow-components/dist/components/Text";

export const IbanText: FC<{ iban: string }> = (props) => {
  const { iban } = props;
  const redactedIban = "**** " + iban.slice(-4);

  return <Text i18n={{ text: redactedIban }} />;
};
